<template>
  <div :class="{ '__point-boundary': true, '__is-loading': isLoading }" style="display: contents">
    <b-row v-for="(point, idx) in sequence" class="g-0" :key="point?.id">
      <div class="__point-icon __timeline">
        <i
          :class="{
            'icon-fill_home': ['START', 'END'].includes(point.activities[0].type),
            'icon-outline_arrow-circle-right': ['PICKUP', 'DROP'].includes(point.activities[0].type),
          }"
        ></i>
      </div>

      <div class="__point-container" v-if="point">
        <div class="__point-address">
          <p class="__point-title">{{ point?.address || '-' }}</p>
          <p v-if="point.activities[0].type == 'START'" class="__point-subtitle">
            {{ $t('deliveryRequest.sequence.startPoint') }}
          </p>
          <p v-else-if="point.activities[0].type == 'END'" class="__point-subtitle">
            {{ $t('deliveryRequest.sequence.endPoint') }}
          </p>
        </div>

        <div class="__point-alert">
          <span
            v-html="$t('deliveryRequest.sequence.missingInfo', {
              departureTime: $t('deliveryRequest.sequence.departureTime'),
              startPoint: $t('deliveryRequest.sequence.startPoint'),
            })"
          ></span>
        </div>
      </div>

      <div v-if="point.activities[0].type != 'END'" class="__point-distance __timeline">
        {{ toKm(sequence[idx + 1]?.distance ?? 0) }} Km
      </div>

      <ActivityTable
        v-if="point.activities"
        :point="point"
      />
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ActivityTable from '../ActivityTable'
import { EventBus } from '@/router/views/fleet-task/lib/event-bus'
import * as FleetTaskPoint from '@/services/rest-api/lib/fleet-task/point'
import datePickerLang from '@/helpers/date-picker-lang'

import moment from 'moment'
moment.locale('id')

export default {
  components: {
    ActivityTable,
  },
  props: {
    sequence: {
      type: Array,
      default: () => [],
    },
    missedRequiredFields: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      value: '',
    }
  },
  computed: {
    ...mapState('fleetTask', ['fleetTaskStatus']),
    datePickerLang() {
      return datePickerLang()
    },
  },
  methods: {
    async handleChangeServiceTime(pointId, newValueAsDate) {
      const res = await FleetTaskPoint.update(this.$route.params.id, pointId, {
        service_time: this.dateToDuration(newValueAsDate),
      })

      if (res.errors) {
        this.$mcToast.error(this.$t('deliveryRequest.toast.serviceTimeChangeFailed'))
        return
      }

      // Refetch sequence
      EventBus.$emit('refetch-sequence')
    },
    durationToSvcTimeFormat(duration) {
      const dur = moment.duration(duration)

      let result = ''
      if (dur.hours() > 0) result += `${dur.hours()} Jam `
      if (dur.minutes() > 0) result += `${dur.minutes()} Menit`

      return result
    },
    durationToDate(duration) {
      const dur = moment.duration(duration)
      return moment()
        .set({
          hours: dur.hours(),
          minutes: dur.minutes(),
          seconds: 0,
          ms: 0,
        })
        .toDate()
    },
    dateToDuration(date) {
      const startOfDay = moment().startOf('day')
      const current = moment(date).set({ seconds: 0, ms: 0 })
      const diff = current.diff(startOfDay)

      return moment.duration(diff).toISOString()
    },
    toDate(date) {
      return moment(date).format('DD MMM')
    },
    toHour(date) {
      return moment(date).format('HH:mm')
    },
    toKm(meter) {
      return parseFloat((meter / 1000).toFixed(2))
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
